const key=username=>'kelimo-recovery-draft:'+String(username||'').trim().normalize('NFC').toLowerCase();
function readRecoveryDraft(username){try{return sessionStorage.getItem(key(username))||'';}catch{return '';}}
function storeRecoveryDraft(username,email){try{if(email.trim())sessionStorage.setItem(key(username),email.trim());else sessionStorage.removeItem(key(username));}catch{}}
module.exports={readRecoveryDraft,storeRecoveryDraft};
